import { render, staticRenderFns } from "./Jump-Page.vue?vue&type=template&id=44b5aeea&scoped=true"
import script from "./Jump-Page.vue?vue&type=script&lang=js"
export * from "./Jump-Page.vue?vue&type=script&lang=js"
import style0 from "./Jump-Page.vue?vue&type=style&index=0&id=44b5aeea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5aeea",
  null
  
)

export default component.exports